const tpl = (fields) => ({ page: 'schedules', ...fields })

export const SCHEDULE_TEMPLATES_PART03 = [
  tpl({
    id: 'demo-tpl-sch-mentions',
    title: 'Brand mention monitor',
    category: 'Research',
    cron: '0 * * * *',
    apps: ['Web research', 'Slack'],
    description: 'Hourly sweep of the web and news for new mentions of your company and products.',
    steps: ['Search news, blogs, and forums for your names', 'Drop anything already reported', 'Post new mentions to #mentions'],
    prompt:
      'Every hour, search the web and news for new mentions of our company and products, and post anything new to Slack #mentions with the source and a one-line summary.',
  }),
  tpl({
    id: 'demo-tpl-sch-invoice-chase',
    title: 'Month-end invoice chase',
    category: 'Ops',
    cron: '0 9 3 * *',
    apps: ['Google Sheets', 'Gmail'],
    description: 'On the 3rd of each month, finds overdue invoices and drafts polite reminders for you to send.',
    steps: [
      'Read the Invoices sheet',
      'Find invoices more than 15 days overdue',
      'Draft a reminder to each billing contact, for your review',
    ],
    prompt:
      'On the 3rd of every month at 9:00, read the Invoices sheet, find invoices more than 15 days overdue, and draft a polite reminder email to each billing contact for me to review.',
  }),
]
